
export default function ProblemSection() {
  const problems = [
    {
      icon: 'ri-arrow-down-line',
      title: 'Manque de visibilité',
      description: 'Votre restaurant se perd dans la masse des concurrents sur les plateformes',
    },
    {
      icon: 'ri-emotion-sad-line',
      title: 'Difficulté à attirer de nouveaux clients',
      description: 'Pas assez de nouvelles commandes malgré la qualité de vos plats',
    },
    {
      icon: 'ri-pause-line',
      title: 'Revenus stagnants',
      description: 'Votre chiffre d\'affaires n\'augmente pas malgré tous vos efforts',
    }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Vous reconnaissez-vous ?
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            <strong>"Trop de concurrence, pas assez de commandes, marges faibles…"</strong>
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {problems.map((problem, index) => (
            <div key={index} className="bg-gray-800 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${problem.icon} text-2xl text-red-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4 text-center">
                {problem.title}
              </h3>
              <p className="text-gray-300 text-center leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-lg text-gray-300 font-medium">
            Et si on vous disait qu'il existe une solution <span className="text-[#9EFD38] font-bold">100% gratuite</span> ?
          </p>
        </div>
      </div>
    </section>
  );
}
